/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Alarm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Set thresholds on your equipment's points and get notified as soon as a value drifts. The log keeps the history of every alarm." |
*
* @param {Go_Further_Alarm_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_alarm_description = /** @type {((inputs?: Go_Further_Alarm_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Alarm_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Set thresholds on your equipment's points and get notified as soon as a value drifts. The log keeps the history of every alarm.")
	return /** @type {LocalizedString} */ ("Définissez des seuils sur les points de vos équipements et recevez une notification dès qu'une valeur dérive. Le journal garde l'historique de chaque alarme.")
});